export default __webpack_public_path__ + "static/media/whyus_3.ffad5ea3.png";